import { it } from 'date-fns/locale/it';
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks';
import { colors } from '../../ui/colors';
import { ArrowLeftIcon } from "../../ui/icons/arrow-left";
import { Layout } from "../../ui/layout";
import { ButtonComponent } from "../../ui/molecules/button/newButton";
import { Banner } from "../../ui/organisms/banner";
import { CustomHorizontalTab } from "../../ui/organisms/customHorizontalTab";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { SuccessPopup } from '../../ui/organisms/successPopup';
import { BoxAnagrafica } from './boxAnagrafica/boxAnagrafica';
import { AnagraphicCreate, resetAnagraphicErrors, setValidateAnagraphicCreationStatus, validateAnagraphicCreation } from "./boxAnagrafica/slice";
import { BoxCDXM026 } from "./boxCDXM026/boxCDXM026";
import { BoxContratti } from "./boxContratti/boxContratti";
import BoxFunzioni from "./boxFunzioni/boxFunzioni";
import BoxOtherData from "./boxOtherData/boxOtherData";
import BoxOtherInfo from "./boxOtherInfo/boxOtherInfo";
import { BoxRequirements } from "./boxRequisiti/boxRequirements";
import { BoxValutazioni } from "./boxValutazioni/boxValutazioni";
import { GetByIdPersonalManagement, PMUpdate, resetGetByIdPersonalManagementResourcesStatus, resetPersonalManagementUpdateStatus, setSelectedTab } from "./slice";
import './style.scss';

registerLocale('it', it)

export function NewStaff() {
    const personalManagement = useAppSelector(state => state.personalManagement)
    const otherInfoState = useAppSelector(state => state.PMOtherInfo)
    const anagraficaState = useAppSelector(state => state.PMAnagrafica)
    const evaluationsState = useAppSelector(state => state.PMEvaluations)
    const contractsState = useAppSelector(state => state.PMContracts)
    const otherDataState = useAppSelector(state => state.PMOtherData)
    const CDXM026State = useAppSelector(state => state.PMCDXM026)
    const functionsState = useAppSelector(state => state.PMFunctions)
    const requirementState = useAppSelector(state => state.PMRequirement)

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [showDeleteSuccess, setShowDeleteSuccess] = useState<boolean>(false)

    const [showError, setShowError] = useState<boolean>(false)


    useEffect(() => {
        if (personalManagement.getByIdPersonalManagementResourcesStatus === 'successfully') {
            dispatch(resetGetByIdPersonalManagementResourcesStatus('idle'))
        }

    }, [personalManagement.getByIdPersonalManagementResourcesStatus])

    useEffect(() => {
        if (anagraficaState.validateAnagraphicCreationStatus === 'successfully') {
            dispatch(setValidateAnagraphicCreationStatus('idle'))
            dispatch(resetAnagraphicErrors())
            dispatch(AnagraphicCreate(anagraficaState.createAnagraphicRequest))
        }
    }, [anagraficaState.validateAnagraphicCreationStatus])

    useEffect(() => {
        if (personalManagement.personalManagementUpdateStatus === 'successfully') {
            dispatch(resetPersonalManagementUpdateStatus())
            dispatch(GetByIdPersonalManagement(personalManagement.currentPersonalManagementId!))
        }
    }, [personalManagement.personalManagementUpdateStatus])

    // CREATION SUCCESS BANNER
    useEffect(() => {
        if (evaluationsState.evaluationCreationStatus === 'successfully' ||
            functionsState.functionCreationStatus === 'successfully' ||
            contractsState.contractCreationStatus === 'successfully' ||
            otherDataState.otherDataCreationStatus === 'successfully' ||
            CDXM026State.CDXM026CreationStatus === 'successfully' ||
            anagraficaState.AnagraphicCreationStatus === 'successfully' ||
            otherInfoState.createOtherInfoStatus === 'successfully' ||
            requirementState.requirementCreationStatus === 'successfully' ||
            requirementState.requirementDetailCreationStatus === 'successfully'
        ) {
            setShowSuccess(true)
        }
    }, [evaluationsState.evaluationCreationStatus,
    contractsState.contractCreationStatus,
    otherDataState.otherDataCreationStatus,
    CDXM026State.CDXM026CreationStatus,
    otherInfoState.createOtherInfoStatus,
    anagraficaState.AnagraphicCreationStatus,
    requirementState.requirementCreationStatus,
    requirementState.requirementDetailCreationStatus,
    functionsState.functionCreationStatus
    ])

    // UPDATE SUCCESS BANNER
    useEffect(() => {
        if (evaluationsState.evaluationUpdateStatus === 'successfully' ||
            contractsState.contractUpdateStatus === 'successfully' ||
            otherDataState.otherDataUpdateStatus === 'successfully' ||
            CDXM026State.CDXM026UpdateStatus === 'successfully' ||
            otherInfoState.OthInfoUpdateStatus === 'successfully' ||
            requirementState.requirementUpdateStatus === 'successfully' ||
            requirementState.requirementDetailUpdateStatus === 'successfully' ||
            personalManagement.personalManagementUpdateStatus === 'successfully'
        ) {
            setShowSuccess(true)
        }
    }, [
        evaluationsState.evaluationUpdateStatus,
        contractsState.contractUpdateStatus,
        otherDataState.otherDataUpdateStatus,
        CDXM026State.CDXM026UpdateStatus,
        otherInfoState.OthInfoUpdateStatus,
        requirementState.requirementUpdateStatus,
        requirementState.requirementDetailUpdateStatus,
        personalManagement.personalManagementUpdateStatus
    ])

    // DELETE SUCCESS BANNER
    useEffect(() => {
        if (evaluationsState.evaluationDeleteStatus === 'successfully' ||
            contractsState.contractDeleteStatus === 'successfully' ||
            otherDataState.otherDataDeleteStatus === 'successfully' ||
            CDXM026State.CDXM026DeleteStatus === 'successfully' ||
            otherInfoState.DeleteIdOtherInfoStatus === 'successfully' ||
            requirementState.requirementDeleteStatus === 'successfully' ||
            requirementState.requirementDetailDeleteStatus === 'successfully'
        ) {
            setShowDeleteSuccess(true)
        }
    }, [
        evaluationsState.evaluationDeleteStatus,
        contractsState.contractDeleteStatus,
        otherDataState.otherDataDeleteStatus,
        CDXM026State.CDXM026DeleteStatus,
        otherInfoState.DeleteIdOtherInfoStatus,
        requirementState.requirementDeleteStatus,
        requirementState.requirementDetailDeleteStatus
    ])

    // ANAGRAPHIC ERROR VALIDATION
    useEffect(() => {
        if (anagraficaState.validateAnagraphicCreationStatus === 'successfully')
            setShowError(false)
        else if (anagraficaState.validateAnagraphicCreationStatus === 'failed')
            setShowError(true)
    }, [anagraficaState.validateAnagraphicCreationStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
        if (showDeleteSuccess) {
            setTimeout(() => {
                setShowDeleteSuccess(false)
            }, 2000)
        }
    }, [showSuccess, showDeleteSuccess])


    return (
        <Layout menuItem={MenuItems.GESTIONE_PERSONALE} breadcrumbItems={['Dashboard', 'Gestione Personale', 'Nuovo Dipendente']}
            headerLabel="Nuovo Dipendente"
            rightBar={true}
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/gestionePersonale')} color={colors.brandPrimary[50]} size={0} />
            }
            headerChildren={
                <div className="flex items-center h-full w-full justify-end gap-2">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Salva"
                        color={"orange"}
                        onClick={() => {
                            if (personalManagement.selectedTab === 1) {
                                dispatch(PMUpdate({ body: personalManagement.personalManagementUpdateRequest, id: personalManagement.currentPersonalManagementId! }))
                            }
                            else
                                dispatch(validateAnagraphicCreation(anagraficaState.createAnagraphicRequest))
                            //dispatch(AnagraphicCreate(anagraficaState.createAnagraphicRequest))
                        }}
                    />
                </div>
            }
        >
            <div>
                {
                    (showSuccess || showDeleteSuccess) &&
                    <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                        <SuccessPopup
                            active={showSuccess || showDeleteSuccess}
                            message="Dati salvati correttamente."
                            onClose={() => {
                                setShowSuccess(false)
                                setShowDeleteSuccess(false)
                            }}
                        />
                    </div>
                }
                {
                    showError &&
                    <Banner
                        errorsList={anagraficaState.anagraphicErrors.errorLabels}
                        type="error"
                        visible={anagraficaState.validateAnagraphicCreationStatus === 'failed'}
                        label={"Si è verificato un errore durante la creazione dell'anagrafica"}
                        closeAction={function (): void {
                            dispatch(setValidateAnagraphicCreationStatus('idle'))
                        }}
                    />
                }
                <div className="bg-white shrink-0">
                    <CustomHorizontalTab
                        selectedIndex={personalManagement.selectedTab}
                        onTabClick={(index) => dispatch(setSelectedTab(index))}
                    >
                        <div>Anagrafica</div>
                        <div>Requisiti</div>
                        <div>Funzioni</div>
                        <div>Valutazioni</div>
                        <div>Contratti</div>
                        <div>Altri dati</div>
                        <div>CDX M026</div>
                        <div>Altre Informazioni</div>
                    </CustomHorizontalTab>
                </div>

            </div>
            <div className="flex h-full bg-brandPrimary-100">
                <div className="fieldset flex-1 bg-brandPrimary-200">
                    {
                        personalManagement.selectedTab === 0 &&
                        <BoxAnagrafica />
                    }
                    {
                        personalManagement.selectedTab === 2 &&
                        <BoxFunzioni />
                    }
                    {
                        personalManagement.selectedTab === 1 &&
                        <BoxRequirements />
                    }
                    {
                        personalManagement.selectedTab === 3 &&
                        <BoxValutazioni />
                    }
                    {
                        personalManagement.selectedTab === 4 &&
                        <BoxContratti />
                    }
                    {
                        personalManagement.selectedTab === 5 &&
                        <BoxOtherData />
                    }
                    {
                        personalManagement.selectedTab === 6 &&
                        <BoxCDXM026 />
                    }
                    {
                        personalManagement.selectedTab === 7 &&
                        <BoxOtherInfo />
                    }

                </div>
            </div >
        </Layout >
    )
}